var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        width: _vm.width,
        "append-to-body": "",
        "close-on-click-modal": false,
        "close-on-press-escape": !_vm.isSubmiting,
        "show-close": !_vm.isSubmiting,
        "destroy-on-close": true,
        "custom-class": "micro-confirmation-modal"
      },
      on: {
        "update:visible": function($event) {
          return _vm.$emit("update:visible", $event)
        },
        closed: function($event) {
          return _vm.$emit("closed")
        }
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isLoading,
              expression: "isLoading"
            }
          ],
          staticClass:
            "px-4 d-flex flex-column justify-content-center align-items-center"
        },
        [
          _vm._t("icon", function() {
            return [
              _c(
                "el-tag",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-center rounded-circle",
                  style: { width: "64px", height: "64px" },
                  attrs: { type: _vm.tagType }
                },
                [_c("i", { class: _vm.icon, style: { fontSize: "32px" } })]
              )
            ]
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-center my-2" },
            [
              _vm._t("header", function() {
                return [
                  _c("h4", { staticClass: "font-weight-bold" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.title) +
                        "\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.description
                    ? _c("h5", { staticClass: "text-muted" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.description) +
                            "\n                "
                        )
                      ])
                    : _vm._e()
                ]
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "d-flex align-items-center justify-content-center mt-3"
            },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    plain: "",
                    disabled: _vm.isLoading || _vm.isSubmiting
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("cancel")
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.cancelText) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: _vm.confirmType,
                    disabled: _vm.disabled || _vm.isLoading || _vm.isSubmiting
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("confirm")
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.confirmText) +
                      "\n\n                "
                  ),
                  _vm.isSubmiting
                    ? _c("i", { staticClass: "el-icon-loading" })
                    : _vm.icon
                    ? _c("i", { class: _vm.icon })
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _vm.$slots.default
        ? [
            _c("el-divider", { staticClass: "mt-3" }),
            _vm._v(" "),
            _vm._t("default")
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6dc7feb2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dc7feb2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_micro/modals/ConfirmationModal.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-6dc7feb2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_micro/modals/ConfirmationModal.vue
// module chunks = 2